import { HOME_DROPDOWN_OPTIONS } from '../../actions/uiActions'
import { itemHelper } from '../../common/src/helpers'

export const checkOwnershipByMode = {
  [HOME_DROPDOWN_OPTIONS.OWNED]: itemHelper.isOwner,
  [HOME_DROPDOWN_OPTIONS.FOLLOWED]: itemHelper.isOwnerOrFollower,
  [HOME_DROPDOWN_OPTIONS.EVERYTHING]: () => true,
}
